import { formatDate } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { OtpVerifyComponent } from "src/app/shared-modules/otp-verify/otp-verify.component";
import { CustomerServiceService } from "../customer-service.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DeleteAccountComponent } from "../delete-account/delete-account.component";
@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit {
  profileLoading: boolean = false;
  public editGeneralInfo = false;
  public editBillingDetails = false;
  public mobileVerified = 0;
  public emailVerified = 0;
  public isGstVerified: boolean = false;
  public isGstVerifying: boolean = false;
  public gstVerificationData: any = null;
  public updateBtn = true;
  public profileUpdate = "NA";
  public profileUpdateButton = false;
  public billingSave = false;
  public save = false;
  public edit1 = true;
  public edit2 = true;
  profileForm!: FormGroup;
  billingForm!: FormGroup;
  maxDate = new Date();
  file: any = "";
  profileImage: any = "";
  dateFormat = "yyyy-MM-dd";
  language = "en";
  loading: boolean = false;
  token: any;
  invalidDate: boolean = false;
  MatDialogref: MatDialogRef<DeleteAccountComponent>;
  matDialogref: MatDialogRef<OtpVerifyComponent> | undefined;
  data = {
    username: "",
    mobile: 0,
    email: "",
    dob: new Date(),
    gender: "",
    company_name: "",
    profile_pic: "",
    designation: "",
    gst: "",
    billing_address: {
      username: "",
      address_line: "",
      area_name: "",
      city: "",
      state: "",
      pincode: "",
      mobile: "",
      gst: "",
      landmark: "",
      gst_verified: false,
    },
  };

  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private services: CustomerServiceService,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    this.profileForm = this.formBuilder.group({
      userName: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: [
        "",
        Validators.compose([
          // Validators.required,
          Validators.pattern(this.emailregex),
        ]),
      ],
      dateOfBirth: [""],
      gender: [""],
      companyName: ["", [Validators.pattern("^[A-Za-z0-9? ,_-]+$")]],
      designation: [""],
      gst: [
        "",
        [Validators.pattern("^[A-Za-z0-9? ,_-]+$"), Validators.maxLength(15)],
      ],
    });
    this.billingForm = this.formBuilder.group({
      billingName: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      billingContact: [
        "",
        [Validators.required, Validators.pattern("^[0-9]{10,10}$")],
      ],
      address: ["", [Validators.required]],
      area: ["", [Validators.required]],
      city: ["", [Validators.required]],
      state: ["", [Validators.required]],
      pincode: ["", [Validators.required, Validators.pattern("^[0-9]{6,6}$")]],
      gst: [
        "",
        [Validators.pattern("^[A-Za-z0-9? ,_-]+$"), Validators.maxLength(15)],
      ],
    });
    this.getProfile();
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
  }

  public get ProfileFormControl() {
    return this.profileForm.controls;
  }
  public get BillingFormControl() {
    return this.billingForm.controls;
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  public getProfile(): void {
    let token = sessionStorage.getItem("token");
    this.services.GetProfile(token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          if (
            response.body.data.billing_address === null ||
            response.body.data.billing_address === undefined
          ) {
            response.body.data.billing_address = {};
            this.data = response.body.data;
          } else {
            this.data = response.body.data;
            this.isGstVerified =
              response.body.data.billing_address.gst_verified === true ||
              response.body.data.billing_address.gst_verified === 1;
          }
          this.profileImage = response.body.data.profile_pic;
          this.mobileVerified = response.body.data.mobile_verified;
          this.emailVerified = response.body.data.email_verified;
        }
      },
      (error) => {
        if (error.status === 401) {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  public onEditProfile(num: number): void {
    this.updateBtn = false;
    this.profileUpdateButton = true;
    this.save = true;
    this.edit1 = false;
    this.edit2 = false;
    if (!this.editGeneralInfo) {
      this.ProfileFormControl["userName"].setValue(this.data.username);
      this.ProfileFormControl["mobile"].setValue(this.data.mobile);
      this.ProfileFormControl["email"].setValue(this.data.email);
      this.ProfileFormControl["companyName"].setValue(this.data.company_name);
      this.ProfileFormControl["designation"].setValue(this.data.designation);
      this.ProfileFormControl["dateOfBirth"].setValue(this.data.dob);
      this.ProfileFormControl["gender"].setValue(this.data.gender);
      this.ProfileFormControl["gst"].setValue(this.data.gst);
      if (this.data.dob != null) {
        this.profileForm.patchValue({
          dateOfBirth: this.formatFormDate(this.data.dob),
        });
      }
    }
    if (num === 1) {
      this.editGeneralInfo = true;
    }
  }
  onEditBillingAddress() {
    this.billingSave = true;
    this.profileUpdateButton = false;
    this.save = false;
    this.edit1 = false;
    this.edit2 = false;
    this.editBillingDetails = true;
    if (this.editBillingDetails) {
      this.BillingFormControl["billingName"].setValue(
        this.data.billing_address.username
      );
      this.BillingFormControl["address"].setValue(
        this.data.billing_address.address_line
      );
      this.BillingFormControl["area"].setValue(
        this.data.billing_address.area_name
      );
      this.BillingFormControl["city"].setValue(this.data.billing_address.city);
      this.BillingFormControl["state"].setValue(
        this.data.billing_address.state
      );
      this.BillingFormControl["pincode"].setValue(
        this.data.billing_address.pincode
      );
      this.BillingFormControl["billingContact"].setValue(
        this.data.billing_address.mobile
      );
      this.BillingFormControl["gst"].setValue(this.data.billing_address.gst);
      this.isGstVerified =
        (this.data.billing_address as any)?.gst_verified === true ||
        (this.data.billing_address as any)?.gst_verified === 1;
    }
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.profileLoading = true;
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.profileLoading = false;
          this.profileImage = response.body.image_link;
        }
        if (response.status == 401) {
          this.router.navigateByUrl("/");
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  GoToDashboard() {
    this.router.navigate(["/dashboard"]);
  }

  public updateProfile(): void {
    if (this.profileForm.valid) {
      this.loading = true;
      this.profileUpdate = "NA";
      let token = sessionStorage.getItem("token");
      const profileData = {
        username: this.ProfileFormControl["userName"].value,
        mobile: this.ProfileFormControl["mobile"].value,
        email: this.ProfileFormControl["email"].value,
        dob: this.ProfileFormControl["dateOfBirth"].value,
        gender: this.ProfileFormControl["gender"].value,
        company_name: this.ProfileFormControl["companyName"].value,
        profile_pic: this.profileImage,
        designation: this.ProfileFormControl["designation"].value,
        gst: this.ProfileFormControl["gst"].value,
      };
      this.services.UpdateProfile(profileData, token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.data = response.body.data;
            this.profileImage = response.body.data.profile_pic;
            this.mobileVerified = response.body.data.mobile_verified;
            this.emailVerified = response.body.data.email_verified;
            this.editBillingDetails = false;
            this.editGeneralInfo = false;
            this.profileUpdateButton = false;
            this.save = false;
            this.edit1 = true;
            this.edit2 = true;
            sessionStorage.setItem("ProfilePic", this.profileImage);
            sessionStorage.setItem("userName", this.data.username);
            this.profileUpdate = "success";
          }
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          return;
        }
      );
      this.updateBtn = false;
      this.getProfile();
    } else {
      this.invalidDate = false;
      if (this.ProfileFormControl["dateOfBirth"].value > this.maxDate) {
        this.invalidDate = true;
      }
      this.profileForm.markAllAsTouched();
    }
  }

  onGstChange(): void {
    this.isGstVerified = false;
    this.gstVerificationData = null;
  }

  verifyGST(rawGst?: any): void {
    const gstValue = typeof rawGst === "string" ? rawGst : this.BillingFormControl["gst"]?.value;
    if (!gstValue || typeof gstValue !== "string" || gstValue.trim() === "") {
      this.snackBar.open("Please enter a GSTIN to verify", "OK", {
        duration: 4000,
      });
      if (this.BillingFormControl["gst"]) {
        this.BillingFormControl["gst"].markAsTouched();
      }
      return;
    }

    const cleanGst = gstValue.replace(/[^A-Za-z0-9]/g, "").trim().toUpperCase();
    if (cleanGst.length !== 15) {
      this.snackBar.open("GSTIN must be exactly 15 alphanumeric characters", "OK", {
        duration: 4000,
      });
      return;
    }

    this.isGstVerifying = true;
    const token = sessionStorage.getItem("token");

    this.services.verifyGST(cleanGst, token).subscribe({
      next: (response: any) => {
        this.isGstVerifying = false;
        let resData = response.body?.data || response.body;

        while (
          resData?.data &&
          typeof resData.data === "object" &&
          !resData.lgnm &&
          !resData.tradeNam &&
          !Array.isArray(resData.data)
        ) {
          resData = resData.data;
        }

        if (
          resData?.error === true ||
          resData?.error === "true" ||
          resData?.code === "400" ||
          resData?.code === 5004 ||
          resData?.code === "5004"
        ) {
          const errMsg =
            (typeof resData.data === "string" ? resData.data : "") ||
            resData.message ||
            "Invalid or unverified GSTIN.";
          this.snackBar.open(errMsg, "Fail", {
            duration: 5000,
          });
          this.isGstVerified = false;
          return;
        }

        const taxpayerList = Array.isArray(resData?.data)
          ? resData.data
          : Array.isArray(resData)
          ? resData
          : null;
        const taxpayer = taxpayerList
          ? taxpayerList[0]
          : resData?.data || resData;

        if (
          !taxpayer ||
          (!taxpayer.lgnm && !taxpayer.tradeNam && !taxpayer.gstin)
        ) {
          this.snackBar.open(
            "GST details not found for this GSTIN.",
            "Fail",
            {
              duration: 5000,
            }
          );
          this.isGstVerified = false;
          return;
        }

        if (taxpayer.sts && taxpayer.sts.toLowerCase().includes("cancel")) {
          this.snackBar.open(
            `Warning: GSTIN Status is ${taxpayer.sts}`,
            "Alert",
            {
              duration: 6000,
            }
          );
        }

        this.isGstVerified = true;
        this.gstVerificationData = taxpayer;

        if (this.editBillingDetails) {
          this.BillingFormControl["gst"].setValue(cleanGst);

          const businessName = (
            taxpayer.tradeNam ||
            taxpayer.lgnm ||
            ""
          ).trim();
          if (
            businessName &&
            !this.BillingFormControl["billingName"].value
          ) {
            this.BillingFormControl["billingName"].setValue(businessName);
          }

          const addr = taxpayer.pradr?.addr;
          if (addr) {
            const addressParts = [addr.bno, addr.flno, addr.bnm, addr.st]
              .map((p: any) =>
                p && typeof p === "string" ? p.trim() : ""
              )
              .filter((p: string) => p.length > 0);
            if (
              addressParts.length > 0 &&
              !this.BillingFormControl["address"].value
            ) {
              this.BillingFormControl["address"].setValue(
                addressParts.join(", ")
              );
            }

            const area = (addr.loc || addr.dst || "").trim();
            if (area && !this.BillingFormControl["area"].value) {
              this.BillingFormControl["area"].setValue(area);
            }

            const city = (addr.city || addr.dst || "").trim();
            if (city && !this.BillingFormControl["city"].value) {
              this.BillingFormControl["city"].setValue(city);
            }

            const state = (addr.stcd || "").trim();
            if (state && !this.BillingFormControl["state"].value) {
              this.BillingFormControl["state"].setValue(state);
            }

            const pincode = (addr.pncd || "").toString().trim();
            if (pincode && !this.BillingFormControl["pincode"].value) {
              this.BillingFormControl["pincode"].setValue(pincode);
            }
          }
        } else {
          if (this.data?.billing_address) {
            (this.data.billing_address as any).gst_verified = true;
            const billingData = {
              billing_address: {
                ...this.data.billing_address,
                gst_verified: true,
              },
            };
            this.services.UpdateProfile(billingData, token).subscribe();
          }
        }

        const nameMsg =
          taxpayer.tradeNam || taxpayer.lgnm
            ? ` (${taxpayer.tradeNam || taxpayer.lgnm})`
            : "";
        this.snackBar.open(
          `GSTIN Verified Successfully${nameMsg}!`,
          "Success",
          {
            duration: 5000,
          }
        );
      },
      error: (error: any) => {
        this.isGstVerifying = false;
        this.isGstVerified = false;
        const errObj = error.error;
        const errMsg =
          (typeof errObj?.data === "string" ? errObj.data : "") ||
          errObj?.message ||
          (typeof errObj?.data?.data === "string" ? errObj.data.data : "") ||
          errObj?.data?.message ||
          error.message ||
          "GST verification failed. Please try again.";
        this.snackBar.open(errMsg, "Fail", {
          duration: 5000,
        });
      },
    });
  }

  updateBillingAddress() {
    if (this.billingForm.valid) {
      this.loading = true;
      let token = sessionStorage.getItem("token");
      const billingData = {
        billing_address: {
          username: this.BillingFormControl["billingName"].value,
          address_line: this.BillingFormControl["address"].value,
          area_name: this.BillingFormControl["area"].value,
          city: this.BillingFormControl["city"].value,
          state: this.BillingFormControl["state"].value,
          pincode: this.BillingFormControl["pincode"].value,
          mobile: this.BillingFormControl["billingContact"].value,
          gst: (this.BillingFormControl["gst"].value || "")
            .trim()
            .toUpperCase(),
          landmark: "",
          gst_verified: !!this.isGstVerified,
        },
      };
      this.services.UpdateProfile(billingData, token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.data = response.body.data;
            this.isGstVerified =
              response.body.data?.billing_address?.gst_verified === true ||
              response.body.data?.billing_address?.gst_verified === 1;
            this.editBillingDetails = false;
            // this.editGeneralInfo = false;
            this.profileUpdateButton = false;
            this.save = false;
            this.billingSave = false;
            this.edit1 = true;
            this.edit2 = true;
          }
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });

          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          return;
        }
      );
      this.getProfile();
    } else {
      this.billingForm.markAllAsTouched();
    }
  }

  public SendOtp(): void {
    const dataValue = {
      email: this.data.email,
      displayText: "Email Address",
    };
    this.matDialogref = this.matDialog.open(OtpVerifyComponent, {
      width: "500px",
      data: {
        dataKey: dataValue,
      },
      // autoFocus: false,
    });

    this.matDialog._getAfterAllClosed().subscribe((result: any) => {
      this.emailVerified = 1;
    });
  }
  deleteaccount(item: any) {
    this.MatDialogref = this.matDialog.open(DeleteAccountComponent, {
      width: "500px",
      data: item,
      autoFocus: false,
    });
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }

  onPasteNumber(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    if (!/^[0-9]+$/.test(pastedText)) {
      event.preventDefault();
    }
  }
}
